<template>
  <div class="password-change-box">
    <h3>Cambiar contraseña</h3>
    <form @submit.prevent="changePassword">
      <v-text-field
        label="Contraseña actual"
        :type="showCurrentPassword ? 'text' : 'password'"
        autocomplete="current-password"
        v-model="currentPassword"
        :disabled="loading"
        :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showCurrentPassword = !showCurrentPassword"
        required
      ></v-text-field>
      <v-text-field
        label="Nueva contraseña"
        :type="showNewPassword ? 'text' : 'password'"
        autocomplete="new-password"
        v-model="newPassword"
        :disabled="loading"
        :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showNewPassword = !showNewPassword"
        required
      ></v-text-field>
      <v-checkbox
        v-model="revokeOldTokens"
        label="Cerrar sesión en todos los dispositivos"
        :disabled="loading"
      ></v-checkbox>
      <v-btn :loading="loading" block depressed color="primary" type="submit"> Cambiar contraseña </v-btn>
    </form>
    <div v-if="message" :style="{ color: messageColor, marginTop: '20px' }">
      {{ message }}
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'

export default {
  name: 'PasswordChange',
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      loading: false,
      message: '',
      messageColor: 'black',
      showCurrentPassword: false,
      showNewPassword: false,
      revokeOldTokens: false,
    }
  },
  methods: {
    async changePassword() {
      this.loading = true
      this.message = ''

      try {
        const response = await api.apiFetch('/auth/change-password', {
          method: 'POST',

          body: JSON.stringify({
            currentPassword: this.currentPassword,
            newPassword: this.newPassword,
            revokeOldTokens: this.revokeOldTokens,
          }),
        })

        if (response.status === 200) {
          this.message = 'Contraseña cambiada correctamente'
          this.messageColor = 'green'
          this.currentPassword = ''
          this.newPassword = ''
        } else {
          this.message = 'Error al cambiar la contraseña'
          this.messageColor = 'red'
        }
      } catch (error) {
        this.message = 'Error de conexión'
        this.messageColor = 'red'
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.password-change-box {
  margin: 20px auto;
  max-width: 500px;
  background-color: rgba(200, 200, 200, 0.2);
  padding: 30px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>
